var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.4999C25.5 24.4352 24.2357 21.496 21.9853 19.3289C19.7348 17.1618 16.6826 15.9443 13.5 15.9443C10.3174 15.9443 7.26516 17.1618 5.01472 19.3289C2.76428 21.496 1.5 24.4352 1.5 27.4999",
    stroke: "#E3B027",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.9444C17.6421 15.9444 21 12.7109 21 8.72222C21 4.7335 17.6421 1.5 13.5 1.5C9.35786 1.5 6 4.7335 6 8.72222C6 12.7109 9.35786 15.9444 13.5 15.9444Z",
    stroke: "#E3B027",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4992 26.0556C31.4992 21.1878 28.4992 16.6667 25.4992 14.5C26.4853 13.7876 27.2739 12.852 27.7951 11.7762C28.3162 10.7003 28.554 9.51734 28.4872 8.33193C28.4205 7.14652 28.0513 5.99523 27.4124 4.97995C26.7735 3.96467 25.8846 3.11671 24.8242 2.51111",
    stroke: "#E3B027",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.b78eaafdcd1858445ae200c5ea20e6dd.svg";
export { ForwardRef as ReactComponent };